import { render, staticRenderFns } from "./batchManage.vue?vue&type=template&id=69446fb6"
import script from "./batchManage.vue?vue&type=script&lang=js"
export * from "./batchManage.vue?vue&type=script&lang=js"
import style0 from "./batchManage.vue?vue&type=style&index=0&id=69446fb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports